<template>
  <div class="my-hd-tab z-flex">
    <div 
      :class="['item',activeMynav==item.name?'active':'']"
      v-for="(item, index) in myNavList" 
      :key="index"
      @click="toUrl(item.url)"
    >
      {{item.title}}
    </div>
  </div>
</template>

<script>
export default {
  name: "myNav",
  props: {
    activeMynav:{
      type:String,
      default:'',
    },
  },
  data() {
    return {
      myNavList:[
        {
          icon:'el-icon-camera',
          title:'我的图库',
          name:'gallery',
          url:'/my/gallery',
        },{
          icon:'el-icon-trophy',
          title:'获奖记录',
          name:'awards',
          url:'/my/awards',
        },{
          icon:'el-icon-document-checked',
          title:'我的投稿',
          name:'match',
          url:'/my/match',
        },{
          icon:'el-icon-picture-outline',
          title:'我的修图',
          name:'ps',
          url:'/my/ps',
        },{
          icon:'el-icon-document',
          title:'我的订单',
          name:'order',
          url:'/my/order',
        }
      ],
    };
  },
  mounted() {
    this.$axios.api.getUserInfo({}, (res) => {
      if (res.code == 200 && res.data.proxy_match_vip == 11) {
        this.myNavList.push({
          icon:'el-icon-document',
          title:'我的社员',
          name:'members',
          url:'/my/members',
        });
        this.myNavList.push({
          icon:'el-icon-document',
          title:'我的收益',
          name:'profit',
          url:'/my/profit',
        });
      }
    });
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.my-hd-tab{
  border-bottom: $border;
  .item{
    padding:20px;
    font-size: 16px;
    cursor: pointer;
    &.active{
      color: $colorMain;
      border-bottom: 2px solid $colorMain;
    }
    &:hover{
      color: $colorMain;
      border-bottom: 2px solid $colorMain;
    }
  }
}
</style>
